<template>
  <div class="card">
    <div class="card-header">
      <h4 style="padding: 10px">Register New Merchant</h4>
    </div>
    <div class="card-body">
      <form class="forms-sample" @submit.prevent="registerMerchant">
        <div class="form-group row" v-if="msg != ''">
          <label class="col-sm-4 col-form-label"></label>
          <div class="col-sm-8">
            <div class="alert alert-warning alert-dismissible fade show" role="alert">
              <strong>{{ msg }}</strong>
              <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-sm-4 col-form-label">Full Name</label>
          <div class="col-sm-8">
            <input type="text" class="form-control" placeholder="Enter merchant's full name"
              v-model="merchantData.fullName" required />
          </div>
        </div>

        <div class="form-group row">
          <label class="col-sm-4 col-form-label">Company Name</label>
          <div class="col-sm-8">
            <input type="text" class="form-control" placeholder="Enter company name"
              v-model="merchantData.companyName" required />
          </div>
        </div>

        <div class="form-group row">
          <label class="col-sm-4 col-form-label">Email</label>
          <div class="col-sm-8">
            <input type="email" class="form-control" placeholder="Enter merchant's email address"
              v-model="merchantData.email" required />
          </div>
        </div>

        <div class="form-group row">
          <label class="col-sm-4 col-form-label">Mobile Number</label>
          <div class="col-sm-8">
            <input type="tel" class="form-control" placeholder="Enter merchant's mobile number"
              v-model="merchantData.mobileNumber" required />
          </div>
        </div>

        <div class="form-group row">
          <label class="col-sm-4 col-form-label">Business Category</label>
          <div class="col-sm-8">
            <select class="form-control" v-model="merchantData.businessCategory" required style="
                background-color: #2b2e4c;
                color: #e9e6e6;
                border: 1px solid #424351;
              ">
              <option value="">Select Business Category</option>
              <option value="retail">Retail</option>
              <option value="service">Service</option>
              <option value="wholesale">Wholesale</option>
              <option value="technology">Technology</option>
              <option value="finance">Finance</option>
              <option value="other">Other</option>
            </select>
          </div>
        </div>
 

        <button type="submit" class="btn btn-primary mt-0 text-white float-right" id="submitBtn">
          Register Merchant
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import { useToast } from "vue-toastification";
import api from "@/shared/menuApi";

export default {
  name: "RegisterMerchant",
  setup() {
    const toast = useToast();
    return { toast };
  },
  data() {
    return {
      msg: "",
      merchantData: {
        fullName: "",
        email: "",
        mobileNumber: "",
        companyName: "",
        businessCategory: "",
        isDeveloper: false
      }
    };
  },
  methods: {
    async registerMerchant() {
      if (this.validateFields()) {
        try {
          const response = await api.doPost('/api/merchant/create', this.merchantData);
          
          if (response.status === "00") {
            this.toast.success(response.message);
            this.$router.push("/merchant/list");
          } else {
            this.msg = response.message || "Failed to register merchant";
          }
        } catch (error) {
          console.error("Error registering merchant:", error);
          this.msg = "An error occurred while registering the merchant";
        }
      }
    },
    validateFields() {
      if (
        this.merchantData.fullName === "" ||
        this.merchantData.companyName === "" ||
        this.merchantData.email === "" ||
        this.merchantData.mobileNumber === "" ||
        this.merchantData.businessCategory === ""
      ) {
        this.msg = "Please complete all required fields";
        return false;
      }
      return true;
    }
  }
};
</script>

<style scoped>
#submitBtn {
  margin-top: 20px;
}

#error {
  margin-top: 40px;
}
</style> 